import { Navigate, Outlet } from 'react-router';
import { getNotFoundPath } from '@/bundle/pages/NotFoundPage/path';
import { useUser } from '@/context/userContext';

export const DevelopersPageProtectedRoute = () => {
  const { user, isMasterAdminRole } = useUser();

  const isAllowRoute = !!user?.organization_user?.organization?.is_api_keys_allowed && isMasterAdminRole;

  if (isAllowRoute) {
    return <Outlet />;
  }

  return <Navigate to={getNotFoundPath()} />;
};
